import { LoadingSkeleton } from '@/components/ui/loading-skeleton'

/**
 * A stay sheet section whose part of the calendar read has not landed: its
 * heading and a quiet block, never nothing. A sheet that opens before the
 * month does must not read as "no cleaning, no review, no deposit".
 */
export function SectionLoading({ label }: { label: string }) {
  return (
    <section
      aria-label={label}
      aria-busy="true"
      data-testid="sheet-section-loading"
      className="space-y-2"
    >
      <h3 className="text-xs font-semibold uppercase tracking-wider text-textFaint">{label}</h3>
      <LoadingSkeleton className="h-10 w-full" />
    </section>
  )
}
